import { createSlice } from '@reduxjs/toolkit';
import { persistor } from '..';
import { resetSettings } from '../gettingStarted/settingsComplete';
import { resetClub } from '../club/clubSlice';

const initialState = {
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload.user;
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    clearCredentials: (state) => {
      state.user = null;
    },
  },
});

export const { setCredentials, clearCredentials, updateUser } =
  authSlice.actions;

export const logout = () => async (dispatch) => {
  localStorage.removeItem('authToken');
  dispatch(clearCredentials()); // очищаємо auth state
  dispatch(resetSettings()); // очищаємо onboarding прогрес
  dispatch(resetClub()); // очищаємо дані клубу
  await persistor.purge(); // очищаємо persisted storage
};

export default authSlice.reducer;
